import { environment } from "../../configs/environment";
import axios from "axios";

const SERVICE_URL = `${environment.baseURL}`;

const doRequest = (prefix, endpointUrl, method, body, headers, options) => {
  const useLocalPorts = environment.useLocalPorts;
  let serviceUrl = SERVICE_URL;
  if (useLocalPorts === true) {
    serviceUrl += ":8080";
  }

  const url = `${serviceUrl}/${prefix}/${endpointUrl}`;

  return axios({
    url,
    method,
    data: body || undefined,
    headers: headers || {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    ...(options || {}),
  });
};

export default class AbstractApi {
  constructor() {
    if (new.target === AbstractApi) {
      throw new TypeError("Cannot construct Abstract instances directly");
    }

    if (
      this.getAmbassadorPrefix === undefined ||
      typeof this.getAmbassadorPrefix !== "function"
    ) {
      throw new TypeError("Must override method getAmbassadorPrefix");
    }
  }

  get = (url, headers, options) =>
    doRequest(this.getAmbassadorPrefix(), url, "get", null, headers, options);

  post = (url, body, headers, options) =>
    doRequest(this.getAmbassadorPrefix(), url, "post", body, headers, options);

  put = (url, body, headers) =>
    doRequest(this.getAmbassadorPrefix(), url, "put", body, headers, null);

  patch = (url, body, headers) =>
    doRequest(this.getAmbassadorPrefix(), url, "patch", body, headers, null);

  delete = (url, headers) =>
    doRequest(this.getAmbassadorPrefix(), url, "delete", null, headers, null);
}
